import { Component, effect, input } from '@angular/core';
import { IPDFViewerApplication } from '../../options/pdf-viewer-application';
import { PDFNotificationService } from '../../pdf-notification-service';
import { ResponsiveVisibility } from '../../responsive-visibility';

@Component({
    selector: 'pdf-open-file',
    templateUrl: './pdf-open-file.component.html',
    styleUrls: ['./pdf-open-file.component.css'],
    standalone: false
})
export class PdfOpenFileComponent {
  public showOpenFileButton = input<ResponsiveVisibility>(true);

  // #2818 modified by ngx-extended-pdf-viewer
  public disable = input<boolean>(false);
  // #2818 end of modification by ngx-extended-pdf-viewer

  private PDFViewerApplication: IPDFViewerApplication | undefined;

  constructor(notificationService: PDFNotificationService) {
    effect(() => {
      this.PDFViewerApplication = notificationService.onPDFJSInitSignal();
    });
  }

  public onClick = (_htmlEvent?: Event, secondaryToolbar?: boolean) => {
    if (!secondaryToolbar) {
      this.PDFViewerApplication?.eventBus?.dispatch('openfile', { source: window });
    }
  };
}
